import { render, staticRenderFns } from "./UpsellPage.vue?vue&type=template&id=d7686938&scoped=true&"
import script from "./UpsellPage.vue?vue&type=script&lang=js&"
export * from "./UpsellPage.vue?vue&type=script&lang=js&"
import style0 from "./UpsellPage.vue?vue&type=style&index=0&id=d7686938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7686938",
  null
  
)

export default component.exports